import { Component, Input } from '@angular/core';
import { IconLink } from './additional-links-block-list.interface';

@Component({
  selector: 'app-additional-links-block-list',
  templateUrl: './additional-links-block-list.component.html',
  styleUrls: ['./additional-links-block-list.component.scss']
})
export class AdditionalLinksBlockListComponent {
  title: string = "";
  links: IconLink[] = [];
  more: boolean = false;

  @Input() set data (value:any){
    this.title = value.title;
    this.links = value.links;
  }
}
